import './instrument'
import './i18n/config'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { reactErrorHandler } from '@sentry/react'
import './index.css'
import App from './App'
import { applyTheme, getThemePreference, subscribeSystemTheme } from './shared/utils/theme'

try {
  applyTheme(getThemePreference())
  subscribeSystemTheme(() => {
    if (getThemePreference() === 'auto') applyTheme('auto')
  })
  if (JSON.parse(localStorage.getItem('setting:bigger-fonts') ?? 'false')) {
    document.documentElement.dataset.fontSize = 'lg'
  }
} catch { /* ignore malformed stored value */ }

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element not found')

createRoot(rootElement, {
  onUncaughtError: reactErrorHandler(),
  onCaughtError: reactErrorHandler(),
  onRecoverableError: reactErrorHandler(),
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
